import React, { useEffect } from "react";
import { ExternalRedirectAuthLogin, useKronicleAuth } from "../../auth";

const AuthExternalRedirect = () => {
  const { handleLogin } = useKronicleAuth();

  useEffect(() => {
    const timer = setTimeout(() => {
      handleLogin();
    }, 1000);
    return () => clearTimeout(timer);
  }, [handleLogin]);

  return (
    <ExternalRedirectAuthLogin
      COGNITO_DOMAIN={process.env.REACT_APP_COGNITO_DOMAIN || "ap-south-1lo9xmmy3w.auth.ap-south-1.amazoncognito.com"}
      CLIENT_ID={process.env.REACT_APP_COGNITO_CLIENT_ID || process.env.REACT_APP_CLIENT_ID || "2ebk1l71j94ipks0b3vuoen615"}
      loginFunc={handleLogin}
      cb={() => {}}
    />
  );
};

export default AuthExternalRedirect;
